// BUNDLED: global-bundle.js
export class B2C_AddressAutocomplete {

	constructor(form, addressType) {
		this.address1Field = form.querySelector(`.${addressType}Address1`);
		this.address2Field = form.querySelector(`.${addressType}Address2`);
		this.cityField = form.querySelector(`.${addressType}City`);
		this.postalField = form.querySelector(`.${addressType}PostalCode`);
		this.stateField = form.querySelector(`.${addressType}state`);
		this.countryField = form.querySelector(`.${addressType}country`);
		this.form = form;
		this.addressType = addressType;

		this.autocomplete = new google.maps.places.Autocomplete(this.address1Field, {
			componentRestrictions: { country: ["us", "ca"] },
			fields: ["address_components"],
			types: ["address"],
		});

		this.address1Field.addEventListener('focusin', (e) => e.target.autocomplete = 'null');
		this.autocomplete.addListener("place_changed", this.fillInAddress.bind(this));

		this.setAddressDropdownPosition();
		this.resizeAddressDropdownListener();
	}

	fillInAddress(x) {
		this.clearFields();
		const place = this.autocomplete.getPlace();
		for (const component of place.address_components) {
			if (component.types.includes("street_number")) {
				this.address1 = `${component.long_name} ${this.address1}`;
				continue;
			} else if (component.types.includes("route")) {
				this.address1 += component.short_name;
				continue;
			} else if (component.types.includes("postal_code")) {
				this.postal = `${component.long_name}${this.postal}`;
				continue;
			} else if (component.types.includes("postal_code_suffix")) {
				this.postal = `${this.postal}-${component.long_name}`;
				continue;
			} else if (component.types.includes("locality")) {
				this.city = component.long_name;
				continue;
			} else if (component.types.includes("administrative_area_level_1")) {
				this.state = component.short_name;
				continue;
			} else if (component.types.includes("country")) {
				this.country = component.short_name;
				continue;
			}
		}

		this.countryField.value = this.country;
		$(this.countryField).trigger('change');
		this.address1Field.value = this.address1;
		this.postalField.value = this.postal;
		this.cityField.value = this.city;
		this.stateField = this.form.querySelector(`.${this.addressType}state`);
		this.stateField.value = this.state;
		this.address2Field.focus();
	}

	clearFields() {
		this.address1 = '';
		this.address2 = '';
		this.postal = '';
		this.city = '';
		this.state = '';
		this.country = '';
	}

	setAddressDropdownPosition() {
		let rootEl = document.querySelector(':root');
		rootEl.style.setProperty('--pac-container-margintop', '-' + $('body.cc_main_body.ext-webkit').css('top'));
	}

	resizeAddressDropdownListener() {
		addEventListener("resize", (event) => { 
			if ($('body.cc_main_body.ext-webkit').css('top')) {
				this.setAddressDropdownPosition();
				$('.pac-container').css('margin-top', '-' + $('body.cc_main_body.ext-webkit').css('top'));
			} 
		});
	}
}